import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div 
          className="widget-error"
          style={{
            padding: '16px',
            backgroundColor: this.props.darkMode ? '#1f2937' : '#fef2f2',
            border: `1px solid ${this.props.darkMode ? '#374151' : '#fecaca'}`,
            borderRadius: '8px',
            color: this.props.darkMode ? '#f87171' : '#dc2626',
            textAlign: 'center'
          }}
        >
          <div style={{ fontSize: '24px', marginBottom: '8px' }}>⚠️</div>
          <div style={{ fontWeight: '600', marginBottom: '4px' }}>
            {this.props.title || 'Widget'} Failed to Load
          </div>
          <div style={{ fontSize: '12px', opacity: 0.8 }}>
            {this.state.error?.message || 'An unexpected error occurred'}
          </div>
          {this.props.onRetry && (
            <button
              onClick={() => this.setState({ hasError: false, error: null })}
              style={{
                marginTop: '8px',
                padding: '4px 12px',
                fontSize: '12px',
                backgroundColor: this.props.darkMode ? '#374151' : '#dc2626',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Retry
            </button>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
